export const updateToken = (state, payload) => {
    state.token = payload
}
